import { EventBus, Events } from "jiffy-store";
import { renderRecaptchaWidget } from "components/jiffy/checkout-user/checkout-modal-wrapper/recaptcha-api-loader";

import "./recaptcha-modal.scss";

// HB-1901: api.js auto-render is one-shot at script init, and `_vote.js.erb`
// previously re-injected the `recaptcha_tags` markup via `innerHTML` after
// each successful vote — `<script>` tags inserted that way do not execute,
// leaving the second-vote modal with an unrendered widget. Use the explicit
// render helper from HB-1895 and re-arm via `grecaptcha.reset(widgetId)`.
//
// Sign-in modal still loads api.js without `?render=explicit`, so on PDPs
// it can auto-render our `.g-recaptcha` div before the first vote opens
// the modal. Replace the container with a fresh empty div before our
// explicit render so we always own the widget id (and the reset path).
//
// Two paths can open this modal: the rspack `SHOW_RECAPTCHA_MODAL` EventBus
// event from `reviews-list-item.js`, and the legacy `.recaptcha-launcher`
// jQuery click handler in `app/assets/javascripts/jiffy_shirts/reviews/index.js`
// which calls `$('#recaptcha-modal').modal('show')` directly. Listen on the
// Bootstrap `show.bs.modal` event so both paths run the same render/reset
// logic regardless of trigger.
const replaceContainerWithFreshDiv = recaptchaModal => {
  const $existing = recaptchaModal.querySelector(".g-recaptcha");
  if (!$existing) return;
  const $fresh = document.createElement("div");
  for (const attr of $existing.attributes) {
    $fresh.setAttribute(attr.name, attr.value);
  }
  delete $fresh.dataset.recaptchaRendered;
  $existing.parentElement.replaceChild($fresh, $existing);
};

// eslint-disable-next-line max-lines-per-function
export default () => {
  const recaptchaModal = document.getElementById("recaptcha-modal");
  if (!recaptchaModal) return;
  const $recaptchaModal = $(recaptchaModal);

  let widgetId = null;
  let renderInFlight = false;

  const renderOrReset = () => {
    if (widgetId !== null) {
      window.grecaptcha?.reset(widgetId);
      return;
    }
    if (renderInFlight) return;

    replaceContainerWithFreshDiv(recaptchaModal);

    renderInFlight = true;
    renderRecaptchaWidget(() => recaptchaModal.querySelector(".g-recaptcha"), {
      callback: window.reCaptchaVerify
    })
      .then(id => {
        widgetId = id;
      })
      .catch(err => {
        // eslint-disable-next-line no-console
        console.error("recaptcha-modal: render failed", err);
        widgetId = null;
      })
      .finally(() => {
        renderInFlight = false;
      });
  };

  $recaptchaModal.on("show.bs.modal", renderOrReset);

  EventBus.on(Events.SHOW_RECAPTCHA_MODAL, ({ target }) => {
    recaptchaModal
      .querySelector(".recaptcha-modal__form")
      .setAttribute("action", target.button.dataset.url);
    $recaptchaModal.modal("show");
  });

  window.reCaptchaVerify = function reCaptchaVerify(response) {
    if (response === $(".g-recaptcha-response").val()) {
      $("#form-recaptcha").submit();
    }
  };

  window.closeVoteModal = () => {
    $recaptchaModal.modal("hide");
  };
};
